import { BrowserMode } from '@/store/modules/entity_browser/config';

const browserModes = Object.values(BrowserMode);

export default {
  state: {
    browserMode: BrowserMode.DOC,
  },
  mutations: {
    setBrowserMode(state, mode) {
      if (!browserModes.includes(mode)) {
        throw new Error(`Invalid browser mode: ${mode}.`);
      }
      state.browserMode = mode;
    },

    toggleBrowserMode(state) {
      const { browserMode } = state;
      const currentIndex = browserModes.indexOf(browserMode);
      const nextMode = browserModes[(currentIndex + 1) % browserModes.length];
      state.browserMode = nextMode;
    },
  },
};
